import {Level} from '../../../shared/Level';

export class VerbalActionEntryCreationDto {
  constructor(
    public id: number,
    public name: string,
    public receptive: Level,
    public productive: Level,
    public examples: string[],
    public categoryId: number,
    public vocabCategoryIds: number[],
    public vocabEntryIds: number[],
    public functionalGrammarCategoryIds: number[],
    public functionalGrammarEntryIds: number[],
    public systemicGrammarCategoryIds: number[],
    public systemicGrammarEntryIds: number[],
    public textPatternIds: number[],
    public textTypeIds: number[],
    public detailedCanDoStatementCategoryIds: number[],
    public detailedCanDoStatementEntryIds: number[],
    public globalCanDoStatementCategoryIds: number[],
    public globalCanDoStatementEntryIds: number[],
    public verbalActionCategoryIds: number[],
    public verbalActionEntryIds: number[]
  ) {
  }
}
